<template>
<div class="summary-list">
  <div class="summary-list-header">
    <div class="summary-list-header__label">{{labels['summary']}}</div>
    <div class="summary-list__reset" v-if="items.length > 0">
      <primary-button :label="labels['reset']" :uppercase="true" @button-click="$emit('reset-click')" />
    </div>
    <div class="summary-list__empty" v-if="items.length === 0">{{labels['summary-empty']}}</div>
  </div>
  <transition-group name="list">
    <div class="summary-item" v-for="item in items" :key="getKey(item)">
      <div class="summary-item-question" v-if="item.question" @click="$emit('item-click', item)">
        <div class="summary-item-question__title">{{labels[item.question.label]}}</div>
        <div class="summary-item-question__answer">{{labels[item.option.label]}}</div>
      </div>
      <div class="summary-item-result" v-if="item.result">{{labels[item.result]}}</div>
      <div class="summary-item-result-note" v-if="item.result && item.note" v-html="labels[item.note]"></div>
      <div class="summary-item-result-note" v-if="item.result == 'ak4'" >{{labels["ak4note"]}}</div>
    </div>
  </transition-group>
</div>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue'
export default {
  name: 'SummaryList',
  components: {
    'primary-button': PrimaryButton
  },
  props: ['items', 'labels'],
  methods: {
    getKey (item) {
      if (item.question) {
        return item.question.label
      } else if (item.result) {
        return item.result
      }
      return item
    }
  }
}
</script>

<style scoped lang="scss">
.summary-list-header {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;

    padding: 20px;

    background-color: rgba(80,157,209,0.3);
}
.summary-list-header__label {
    margin-top: 7px;
    margin-bottom: 10px;

    text-transform: uppercase;

    font-size: 18px;
    font-weight: bold;
}
.summary-list__empty {
    flex-basis: 100%;

    width: 100%;
    margin-top: 15px;
}
.summary-item-question {
    margin-bottom: 5px;
    padding: 20px;

    cursor: pointer;

    background-color: rgba(243,235,226,0.4);

    .summary-item-question__title {
    }
    .summary-item-question__answer {
        margin-top: 8px;

        font-size: 16px;
        font-weight: bold;
    }
}
.summary-item-result {
    flex: 1;

    margin-bottom: 5px;
    padding: 13px 20px 10px;

    text-transform: uppercase;

    background-color: rgba(80,157,209,0.3);
}
.summary-item-result-note {
    flex: 1;

    margin-bottom: 5px;
    margin-top: -4px;
    padding: 13px 20px 10px;

    background-color: rgba(80,157,209,0.1);
}
.list-item {
    display: inline-block;

    margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
    transition: all 200ms;
}
.list-enter {
    transform: translateX(-40px);

    opacity: 0;
}
.list-leave-to {
    transform: translateX(40px);

    opacity: 0;
}
@media only screen and (min-width: 350px) {
    .summary-list-header {
        flex-direction: row;
        justify-content: space-between;
    }
    .summary-list-header__label {
        margin-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SummaryList.vue